import { Sparkles, Cake, Car, Home, Layers } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

export const OPP_STYLE = {
  kasko: { label: "Kasko yok", hint: "5 yaşından küçük araç, trafiği var — kasko öner", icon: Car },
  imm: { label: "İMM yok", hint: "Trafiği var, İhtiyari Mali Mesuliyet öner", icon: Car },
  yol: { label: "Yol yardım yok", hint: "Trafiği var, yol yardım paketi öner", icon: Car },
  dask: { label: "DASK yok", hint: "Konutu var, zorunlu DASK öner", icon: Home },
  konut: { label: "Konut yok", hint: "DASK'ı var, konut sigortası öner", icon: Home },
  tek: { label: "Tek poliçe", hint: "Sadece bir poliçesi var, başka ürün öner", icon: Layers },
  dogum: { label: "Doğum günü", hint: "Kutlama mesajı gönder", icon: Cake },
};

const Line = ({ o }) => {
  const S = OPP_STYLE[o.code] || {};
  const I = S.icon || Sparkles;
  return (
    <li className="flex items-start gap-2.5 py-1.5">
      <span className={`mt-0.5 h-6 w-6 shrink-0 rounded-md grid place-items-center ${o.code === "dogum" ? "bg-pink-50 text-pink-600" : "bg-amber-50 text-amber-600"}`}><I className="h-3.5 w-3.5" /></span>
      <div><p className="text-[13px] font-medium text-zinc-900 leading-tight">{o.label}</p><p className="text-[11px] text-zinc-500">{S.hint}</p></div>
    </li>
  );
};

export const OppChips = ({ items = [], id }) => {
  if (!items.length) return null;
  const bday = items.some((o) => o.code === "dogum");
  const cross = items.filter((o) => o.code !== "dogum").length;
  return (
    <HoverCard openDelay={80} closeDelay={60}>
      <HoverCardTrigger asChild>
        <button type="button" data-testid={`opp-badge-${id}`} aria-label="Satış fırsatları"
          className="inline-flex items-center gap-1 rounded-full bg-amber-50 border border-amber-200/80 pl-1.5 pr-2 py-0.5 text-[11px] font-semibold text-amber-700 hover:bg-amber-100 transition-colors">
          {bday && <Cake className="h-3 w-3 text-pink-500" />}
          {cross > 0 && <><Sparkles className="h-3 w-3" />{cross}</>}
        </button>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="w-64 p-3" data-testid={`opp-panel-${id}`}>
        <p className="text-[10px] font-semibold uppercase tracking-wider text-amber-600">Satış fırsatları</p>
        <ul className="mt-1 divide-y divide-zinc-100">{items.map((o) => <Line key={o.code} o={o} />)}</ul>
      </HoverCardContent>
    </HoverCard>
  );
};
